{
	"ca": {
		"header": {
			"title": "Com es veurà l’eclipsi des de...?",
			"subtitle": "Utilitza el buscador o clica sobre un punt en el mapa per saber hora, durada i altres dades."
		},
		"map": {
			"hideShadows": "Amagar ombres",
			"showShadows": "Mostrar ombres"
		},
		"tooltip": {
			"noData": "No hi ha dades de l’eclipsi",
			"loadError": "Error carregant la informació",
			"start": "Inici:",
			"totalEclipse": "Eclipsi total",
			"partialEclipse": "Eclipsi parcial",
			"totalityStart": "Inici de la totalitat:",
			"maximum": "Punt màxim:",
			"totalityEnd": "Final de la totalitat:",
			"duration": "Durada:",
			"eclipseEnd": "Final de l’eclipsi:",
			"sunset": "Posta de Sol*:",
			"sunsetNote": "*El Sol es pondrà abans que acabi l’eclipsi.",
			"seconds": "s",
			"minutes": "m"
		},
		"terrain": {
			"noData": "Sense dades sobre el relleu",
			"visible": "El relleu no hauria de tapar el Sol",
			"partial": "El relleu podria tapar una part del Sol",
			"limited": "Visibilitat molt limitada pel relleu",
			"notVisible": "El relleu podria tapar completament el Sol"
		},
		"legend": {
			"officialPoints": "Punts d’observació oficial",
			"moreInfo": "Més informació",
			"totalityBand": "Franja d’eclipsi total",
			"source": "Font:",
			"visibilityNote": "La posició exacta i el relleu de l’horitzó poden afectar la visibilitat de l’eclipsi"
		},
		"mapbox": {
			"FullscreenControl.Enter": "Pantalla completa",
			"FullscreenControl.Exit": "Torna",
			"ScrollZoomBlocker.CmdMessage": "Fes ⌘ + scroll per fer zoom al mapa",
			"ScrollZoomBlocker.CtrlMessage": "Fes ctrl + scroll per fer zoom al mapa"
		}
	},
	"es": {
		"header": {
			"title": "¿Cómo se verá el eclipse desde...?",
			"subtitle": "Utiliza el buscador o haz clic en un punto del mapa para saber la hora, la duración y otros datos."
		},
		"tooltip": {
			"noData": "No hay datos del eclipse",
			"loadError": "Error al cargar la información",
			"start": "Inicio:",
			"totalEclipse": "Eclipse total",
			"partialEclipse": "Eclipse parcial",
			"totalityStart": "Inicio de la totalidad:",
			"maximum": "Punto máximo:",
			"totalityEnd": "Final de la totalidad:",
			"duration": "Duración:",
			"eclipseEnd": "Final del eclipse:",
			"sunset": "Puesta de Sol*:",
			"sunsetNote": "*El Sol se pondrá antes de que termine el eclipse.",
			"seconds": "s",
			"minutes": "min"
		},
		"terrain": {
			"noData": "Sin datos sobre el relieve",
			"visible": "El relieve no debería tapar el Sol",
			"partial": "El relieve podría tapar una parte del Sol",
			"limited": "Visibilidad muy limitada por el relieve",
			"notVisible": "El relieve podría tapar completamente el Sol"
		},
		"legend": {
			"officialPoints": "Puntos de observación oficiales",
			"moreInfo": "Más información",
			"totalityBand": "Franja de eclipse total",
			"source": "Fuente:",
			"visibilityNote": "La posición exacta y el relieve del horizonte pueden afectar a la visibilidad del eclipse"
		},
		"mapbox": {
			"FullscreenControl.Enter": "Pantalla completa",
			"FullscreenControl.Exit": "Vuelve",
			"ScrollZoomBlocker.CmdMessage": "Usa ⌘ + scroll para hacer zoom en el mapa",
			"ScrollZoomBlocker.CtrlMessage": "Usa ctrl + scroll para hacer zoom en el mapa"
		}
	}
}
